<!--

Denna är tänkt att användas när man enbart vill ha tillgång till detailjerna för ett rentalobjekt,
och styra presentationen själv via en slot.
-->
<template>
  <div>
    <Loader v-if="showLoader" size="sm" />
    <slot
      v-else
      v-bind:blueprint="blueprint"
      v-bind:address="address"
      v-bind:objectType="objectType"
      v-bind:publishedToHasPast="publishedToHasPast"
      v-bind:image="image"
      v-bind:subtypeCaption="subtypeCaption"
      v-bind:typeCaption="typeCaption"
      v-bind:subCaption="subCaption"
      v-bind:waitingListType="waitingListType"
      v-bind:waitingListTypeCaption="waitingListTypeCaption"
      v-bind:quantityBRA="quantityBRA"
      v-bind:monthRent="monthRent"
      v-bind:vacantFromText="vacantFromText"
      v-bind:imageUrl="imageUrl"
    />
  </div>
</template>
<script>
import Loader from '@/components/ui/loader';
import RentalObjectMixin from '@/mixins/rentalobject';

export default {
  mixins: [RentalObjectMixin],
  components: { Loader },
  props: {
    rentalObject: {
      type: Object,
      required: false,
    },
    objectCode: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      showLoader: true,
    };
  },

  computed: {
    _rentalObject() {
      if (this.rentalObject) {
        return this.rentalObject;
      } else {
        return this.$store.getters.getObjectByObjectCode(this.objectCode);
      }
    },
  },

  created() {
    if (this.objectCode) {
      this.$store.dispatch('fetchSingleRentalObject', this.objectCode).finally(() => {
        this.showLoader = false;
      });
    } else if (this.rentalObject) {
      this.showLoader = false;
    } else {
      console.error('rentalobjecttemplate.vue Varken rentalObject eller objectCode satt :(');

      this.showLoader = false;
    }
  },
};
</script>
